import React from "react";

export const CopyRight = ({}) => {
  const date = new Date();
  // const classes = loginFragments();

  return (
    <p className="">
      Copyright © {date.getFullYear()} CareTech. All Rights Reserved.
    </p>
  );
};
